if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.productId = this.dataset.productId;
      this.form = this.querySelector('form');
      this.form.querySelector('[name="id"]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartDrawer = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.buyNowButton = this.querySelector('[data-fast-checkout]');
      this.checkoutInput = this.querySelector('input[name="return_to"][value="/checkout"]');

      if (this.buyNowButton) {
        this.buyNowButton.addEventListener('click', () => {
          this.buyNowButton.setAttribute('aria-disabled', true);
          this.buyNowButton.classList.add('is-loading');
          this.checkoutInput && this.checkoutInput.removeAttribute('disabled');
          this.form.submit();
        });
      }
    }

    onSubmitHandler(event) {
      if (!this.cartDrawer) return;

      event.preventDefault();
      if (this.submitButton.classList.contains('is-loading')) return;

      this.handleErrorMessage();
      this.cartDrawer.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('is-loading');

      const fetchedData = this.addItemToCart();
      this.handleFetchedData(fetchedData);
    }

    addItemToCart() {
      return new Promise((resolve, reject) => {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        this.submittedItemPayload = this.getSubmittedItemPayload(formData);
        if (typeof this.cartDrawer.getSectionsToRender === 'function') {
          formData.append('sections', this.cartDrawer.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
        }
        config.body = formData;
        window.__pdpUpsellPopupPending = true;

        fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            this.submittedItemPayload.preAddCartProductIds = (cart.items || []).map((item) =>
              Number(item.product_id || 0)
            );
            return fetch(`${routes.cart_add_url}`, config);
          })
          .then((response) => response.json())
          .then((response) => {
            if (response) {
              resolve(response);
              return;
            }

            this.submitButton.classList.remove('is-loading');
            this.submitButton.removeAttribute('aria-disabled');

            reject(response);
          })
          .catch((e) => {
            window.__pdpUpsellPopupPending = false;
            window.console.error(e);
          });
      });
    }

    handleFetchedData(promise) {
      Promise.all([promise]).then((values) => {
        if (values.length === 0) {
          window.__pdpUpsellPopupPending = false;
          return;
        }

        const fetchedData = values[0];

        if (fetchedData.status) {
          window.__pdpUpsellPopupPending = false;
          this.handleErrorMessage(fetchedData.description);
          return;
        }

        const pdpAddedDetail = this.dispatchPdpAddedEvent(fetchedData);
        window.__pdpUpsellPopupPending = false;
        if (!pdpAddedDetail?.deferCartDrawer) {
          if (typeof this.cartDrawer.handleAddedItem === 'function') {
            this.cartDrawer.handleAddedItem(fetchedData);
          } else if (typeof window.refreshCartDrawer === 'function') {
            window.refreshCartDrawer({ open: true });
          }
        }

        const quickview = document.querySelector(`#Product-Quickview-${this.productId}`);

        if (quickview) {
          quickview.hide();
        }
      })
        .catch((error) => {
          window.console.error(error);
        })
        .finally(() => {
          window.__pdpUpsellPopupPending = false;
          this.submitButton.classList.remove('is-loading');
          this.submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.main-product__form-error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.main-product__form-error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    getSubmittedItemPayload(formData) {
      const sellingPlanValue = formData.get('selling_plan');

      return {
        productId: Number(this.productId),
        variantId: Number(formData.get('id')),
        quantity: Number(formData.get('quantity') || 1),
        sellingPlanId: sellingPlanValue ? String(sellingPlanValue) : null,
        preAddCartProductIds: []
      };
    }

    dispatchPdpAddedEvent(fetchedData) {
      const eventDetail = {
        productId: this.submittedItemPayload?.productId || Number(this.productId),
        variantId: Number(fetchedData?.id || this.submittedItemPayload?.variantId || 0),
        quantity: Number(fetchedData?.quantity || this.submittedItemPayload?.quantity || 1),
        sellingPlanId: this.submittedItemPayload?.sellingPlanId || null,
        lineItemKey: fetchedData?.key || null,
        preAddCartProductIds: this.submittedItemPayload?.preAddCartProductIds || [],
        item: fetchedData
      };

      document.dispatchEvent(new CustomEvent('arrae:pdp:added', { detail: eventDetail }));
      return eventDetail;
    }
  });
}
